import styled from 'styled-components/native';

import { DialogButton } from 'components/Button';

export default styled(DialogButton).attrs({ secondary: true })`
  width: 100%;
  margin-top: 5px;
`;
